import { Icon20Cancel } from '@vkontakte/icons';
import { Button, Text, Title } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { type FC, memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import { renderFullScreenAiPhotoGeneration } from 'reactApp/ui/AiPhotoGeneration/Modals/MainScreen/FullScreenAiPhotoGenerationModal.helpers';
import { setAiPhotoGenerationPromoBannerHidden } from 'reactApp/ui/AiPhotoGeneration/Promo/Banner/AiPhotoGenerationPromoBanner.helpers';
import { sendXray } from 'reactApp/utils/ga';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './AiPhotoGenerationPromoBanner.css';

interface IProps {
    setHidden: (hidden: boolean) => void;
}

const title = 'Нейросеть, нарисуй!';
const description = 'Создаст изображение по вашему запросу в 8 разных стилях';
const button = 'Попробовать';

const banner_type = 'entry-point';

export const AiPhotoGenerationPromoBanner: FC<IProps> = memo(function AiPhotoGenerationPromoBanner(props) {
    const { setHidden } = props;

    const isDarkTheme = useSelector(isCurrentDarkTheme);

    const dispatch = useDispatch();

    useEffect(() => {
        sendXray(['ai-gen-promo-ban-show']);
        sendPaymentGa({
            eventCategory: ECategoryGa.aiPhotoGeneration,
            action: 'banner-show',
            banner_type,
            dwh_enabled: true,
            dwh_enabled_fields: [['banner_type']],
        });
    }, []);

    const handleClick = useCallback(() => {
        setHidden(true);
        renderFullScreenAiPhotoGeneration();
        dispatch(setAiPhotoGenerationPromoBannerHidden());
        sendXray(['ai-gen-promo-ban-click']);
        sendPaymentGa({
            eventCategory: ECategoryGa.aiPhotoGeneration,
            action: 'banner-click',
            banner_type,
            dwh_enabled: true,
            dwh_enabled_fields: [['banner_type']],
        });
    }, [setHidden, dispatch]);

    const handleClose = useCallback(() => {
        setHidden(true);
        dispatch(setAiPhotoGenerationPromoBannerHidden());
        sendXray(['ai-gen-promo-ban-close']);
        sendPaymentGa({
            eventCategory: ECategoryGa.aiPhotoGeneration,
            action: 'banner-close',
            banner_type,
            dwh_enabled: true,
            dwh_enabled_fields: [['banner_type']],
        });
    }, [setHidden, dispatch]);

    const image = `${cdnPackagesUrl}/static/cloud/promo/aiPhotoGeneration/home/banner2.webp`;

    return (
        <div className={classNames(styles.root, { [styles.root_dark]: isDarkTheme })} data-qa-id="ai-photo-generation-promo-banner">
            <img src={image} className={styles.img} data-qa-id="image" />
            <div className={styles.rightContainer}>
                <div className={styles.textContainer}>
                    <Title level="3" data-qa-id="title">
                        {title}
                    </Title>
                    <Text data-qa-id="description">{description}</Text>
                </div>
                <Button appearance="overlay" size="l" className={styles.button} onClick={handleClick} data-qa-id="button">
                    {button}
                </Button>
                <Icon20Cancel className={styles.closeIcon} onClick={handleClose} data-qa-id="close" />
            </div>
        </div>
    );
});
